"use client";

import { pageConfig as config } from "~/config/_pages/faq";
import { useCallback, useState } from "react";
import FaqItem from "~/components/_pages/faq/item";
import SearchBoxUI from "~/components/ui/searchbox";
import GreeterUI from "~/components/ui/greeter";
import type { FaqDocument } from "~/types/docs/faq-document";
import { api } from "~/trpc/react";

/*
  @CONSUME pattern is a clean way for seperating
  -client-side/server-side data fetching
*/

interface ConsumeProps {
  initialData: FaqDocument[];
}

export default function Consume({ initialData }: ConsumeProps) {
  const [search, setSearch] = useState<string>("");
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    mutate,
    data: searchData,
    isPending: searchPending,
  } = api.faq.search.useMutation();

  const toggleCallback = useCallback((index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  }, []);

  const searchCallback = useCallback(
    (searchTerm: string) => {
      mutate(searchTerm);
      setSearch(searchTerm);
    },
    [mutate],
  );

  return (
    <main className="container mx-auto max-w-7xl pb-32">
      <GreeterUI className="mb-3 lg:mb-12">
        <GreeterUI.Sub text={config.suptitle} />
        <GreeterUI.Title text={config.title} />
      </GreeterUI>
      <div className="relative z-20 w-full space-y-4 p-3 sm:p-6 lg:mx-auto lg:w-75/100">
        <SearchBoxUI handleSearch={searchCallback} />

        {!search || searchPending
          ? initialData?.map((faq) => (
              <FaqItem
                key={faq.id}
                faq={faq}
                open={faq.id == openIndex}
                toggle={toggleCallback}
              />
            ))
          : (searchData?.hits)?.map((faq) => (
              <FaqItem
                key={faq.id}
                faq={faq}
                open={faq.id == openIndex}
                toggle={toggleCallback}
              />
            ))}
      </div>
    </main>
  );
}
